import { ModularContentSearchSectionFragment } from "src/__generated__/cms-schema.codegen";
import { Hx } from "src/components/Heading/Heading";
import { useTranslatedString } from "src/i18n/hooks";
import { SearchInput } from "../../components/Search/SearchInput";
import { SearchResult } from "../../components/Search/SearchResult";
import {
	SearchProvider,
	useSearchContext,
} from "../../components/Search/hooks";
type SearchSectionProps = ModularContentSearchSectionFragment;

export const SearchSection: React.FC<SearchSectionProps> = () => {
	return (
		<SearchProvider resultsPerPage={10}>
			<SearchSectionContent />
		</SearchProvider>
	);
};

const SearchSectionContent: React.FC = () => {
	const t = useTranslatedString();
	const { state, data, isEmptyInput, isEmptyResult, isError, isLoading } =
		useSearchContext();

	const totalResults = data?.totalResults ?? null;

	const subtitle = (() => {
		if (isEmptyInput) return t("search.subtitle");

		if (isLoading) return <>&nbsp;</>;

		if (isError) return t("search.emptyResult");

		if (totalResults !== null && totalResults > 0) {
			return t("search.totalResults", { count: totalResults });
		}

		if (isEmptyResult) return t("search.emptyResult");

		return <>&nbsp;</>;
	})();

	return (
		<div className="bg-brand-light-bright text-brand-blue py-20">
			<div className="max-w-container mx-auto px-4">
				<div className="flex flex-col gap-1 lg:gap-2">
					<Hx size="h2" className="text-center">
						{t("search.title")}
						{state.query.length > 0 &&
						data?.totalResults &&
						data.totalResults > 0
							? ` "${state.query}"`
							: ""}
					</Hx>
					<p className="text-center">{subtitle}</p>
				</div>
				<div className="py-6 lg:py-8 bg-brand-light-bright">
					<SearchInput />
				</div>
				<SearchResult />
			</div>
		</div>
	);
};

// 🔬 TBD
